import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import api from "axios.config";

import {
  NotificationsAllParams,
  NotificationsAllSuccess,
} from "./notifications.type";

export const useNotificationsAll = (params: NotificationsAllParams) =>
  useQuery<NotificationsAllSuccess, AxiosError<GlobalErrorResponse>>({
    queryKey: ["notifications-all", params],

    queryFn: async ({ signal }) =>
      api
        .get(`${process.env.REACT_APP_API_ALL_NOTIFICATIONS}`, {
          signal,
          params,
        })
        .then((r) => r.data),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    // refetchInterval: 5 * 60 * 1000, // 5 minutes in
  });
